// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3UnCw","footer":"ModalInfo_footer__2ThhL"};